<template>
  <v-menu
      dark
      bottom
      right
      nudge-bottom="28"
      :close-on-content-click=true
      :close-on-click=true
      v-model="genreMenuOpen"
  >
    <template v-slot:activator="{ on: { click }}">
      <div class="genre-dropdown-title-cont" @click="(click)(genreMenuOpen = !genreMenuOpen)">
        <div class="genre-dropdown-title" :style="{ color: genreMenuOpen ? $vuetify.theme.themes.dark.primary : '#fff' }">{{ genre }}</div>
        <img
            src="../assets/graphic/button-dropdown-arrow.svg"
            alt="dropdown-arrow"
            width="11"
            height="7"
            :style="{ transform: genreMenuOpen ? 'rotate(180deg)' : 'none' }"
        />
      </div>
    </template>
    <v-list :width=" $vuetify.breakpoint.xs ? '200px': '271px'" height="300px" class="genre-dropdown-list">
      <v-list-item
          v-for="(genre, key) in genreList"
          :key="key"
          @click="onSelectGenre(genre)"
      >
        <v-list-item-title class="genre-dropdown-item">{{ genre }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
  export default {
    component: 'GenreDropdown',
    props: {
      onClickListItem: {
        type: Function
      },
      defaultSelect: {
        type: String,
        default: ''
      },
      isForm: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        genre: this.defaultSelect ? this.defaultSelect : 'All Music Genres',
        genreMenuOpen: false,
        genreList: [
          'Alternative',
          'Blues',
          'Classical',
          'Country',
          'Dance & Electronic',
          'Hip Hop/Rap',
          'Holiday',
          'Instrumental',
          'Jazz',
          'Musical Theatre',
          'Orchestra',
          'Pop',
          'R&B',
          'Rock',
          'Religious/Gospel',
          'Singer/Songwriter',
          'Vocal/A capella',
          'World'
        ]
      }
    },
    methods: {
      onSelectGenre(genre) {
        this.genre = genre;
        this.onClickListItem(genre);
      }
    },
    created () {
      if (!this.isForm) {
        this.genreList.unshift ('All Music Genres');
      }
    }
  }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
  .genre-dropdown-title-cont {
    width: 180px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 3%;
    cursor: pointer;
  }

  .genre-dropdown-title {
    font-family: Lato-Bold, sans-serif;
    font-size: 15px;
    text-transform: uppercase;
  }

  .genre-dropdown-list {
    overflow-x: scroll;
  }

  .genre-dropdown-item {
    font-family: Lato-Regular, sans-serif;
    font-size: 15px;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .genre-dropdown-title-cont {
      width: 160px;
    }

    .genre-dropdown-title,
    .genre-dropdown-item, {
      font-size: 12px;
    }
  }
</style>